import { useState } from "react";

import Button from "../../../mantine/button/Button";
import { UserIdentityWithAuthorizations } from "../withAuthorizations";
import AddAccountModal from "./AddAccountModal";
import { ConnectedAccountRow } from "./ConnectedAccountRow";
import styles from "./ConnectedAccounts.module.scss";

export const ConnectedAccounts = ({
  siteId,
  identities,
}: {
  siteId: number;
  identities: UserIdentityWithAuthorizations[];
}) => {
  const [isAddAccountModalOpen, setIsAddAccountModalOpen] = useState(false);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h3>Connected Accounts</h3>
        <Button
          variant="outlined"
          onClick={() => setIsAddAccountModalOpen(true)}
        >
          Add Account
        </Button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Account</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {identities.map((identity) => {
            return (
              <ConnectedAccountRow
                key={identity.record.id}
                identity={identity}
                siteId={siteId}
              />
            );
          })}
          {identities.length === 0 && (
            <tr>
              <td colSpan={4}>
                <div className={styles.noAccountsContainer}>
                  <p>No accounts connected</p>
                  <Button onClick={() => setIsAddAccountModalOpen(true)}>
                    Add Account
                  </Button>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <AddAccountModal
        isOpen={isAddAccountModalOpen}
        onClose={() => setIsAddAccountModalOpen(false)}
      />
    </div>
  );
};
